import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { merge, Observable, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { getCurrentLanguage, State } from '@ecap3/core';
import { FuseNavigationService } from '@ecap3/template-atlas';

@Component({
    selector: 'fuse-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseNavigationComponent implements OnInit {
    @Input()
    layout = 'vertical';

    @Input()
    navigation: any;

    lang$: Observable<string>;
    langSub: Subscription;
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     *
     * param {ChangeDetectorRef} _changeDetectorRef
     * param {FuseNavigationService} _fuseNavigationService
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private readonly translateService: TranslateService,
        private store: Store<State>,


    ) {
        this.lang$ = this.store.select(getCurrentLanguage);

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.langSub = this.lang$.subscribe({
            next: (lang) => {
                // this.selectedLang = lang;
                this.translateService.use(lang);
            }
        });

        // Load the navigation either from the input or from the service
        this.navigation = this.navigation || this._fuseNavigationService.getCurrentNavigation();
        // Subscribe to the current navigation changes
        this._fuseNavigationService.onNavigationChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: () => {
                    // Load the navigation
                    this.navigation = this._fuseNavigationService.getCurrentNavigation();

                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                }
            });

        // Subscribe to navigation item
        merge(
            this._fuseNavigationService.onNavigationItemAdded,
            this._fuseNavigationService.onNavigationItemUpdated,
            this._fuseNavigationService.onNavigationItemRemoved
        ).pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: () => {
                    // Mark for check
                    this._changeDetectorRef.markForCheck();
                }
            });
    }
}
